// extracted by mini-css-extract-plugin
module.exports = {"contentComponent":"StripeSettingsList_contentComponent__1YFEe","tableContainer":"StripeSettingsList_tableContainer__2oybR","root":"StripeSettingsList_root__2LhQ1"};